import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../pages/Home.vue'
import Products from '../pages/Products.vue'
import Application from '../pages/Application.vue'
import Service from '../pages/Service.vue'
import AboutUs from '../pages/AboutUs.vue'
import NewLists from '../pages/NewLists.vue'
import NewDetail from '../pages/NewDetail.vue'
import ProductsCenter from "../pages/ProductsCenter.vue"
import ProductsList from "../pages/ProductsList.vue"
import Search from "../pages/Search.vue"

Vue.use(VueRouter)

export default new VueRouter({
	routes: [{
		path: '/',
		name: 'Home',
		component: Home
	},
	{
		path: '/Products',
		name: 'Products',
		component: Products
	},
	{
		path: '/Application',
		name: 'Application',
		component: Application
	},
	{
		path: '/Service',
		name: 'Service',
		component: Service
	},
	{
		path: '/AboutUs',
		name: 'AboutUs',
		component: AboutUs
	},
	{
		path: '/NewLists',
		name: 'NewLists',
		component: NewLists
	},
	{
		path: '/NewDetail',
		name: 'NewDetail',
		component: NewDetail
	},
	{
		path: '/ProductsCenter',
		name: 'ProductsCenter',
		component: ProductsCenter
	},
	{
		path: '/ProductsList',
		name: 'ProductsList',
		component: ProductsList
	},
	{
		path: '/Search',
		name: 'Search',
		component: Search
	}]
})
